import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../../models/api-response';
import { AdminUser, UpdateAdminRoleRequest } from '../../models/admin-user';

@Injectable({ providedIn: 'root' })
export class AdminUsersService {
  constructor(private http: HttpClient) { }

  getAll() {
    return this.http.get<ApiResponse<AdminUser[]>>(
      `${environment.apiBaseUrl}/admin/users`
    );
  }

  activate(id: string) {
    return this.http.post<ApiResponse<AdminUser>>(
      `${environment.apiBaseUrl}/admin/users/${id}/activate`,
      {}
    );
  }

  resetPassword(id: string, newPassword: string) {
    return this.http.post<ApiResponse<AdminUser>>(
      `${environment.apiBaseUrl}/admin/users/${id}/reset-password`,
      { newPassword }
    );
  }

  disable(id: string) {
    return this.http.post<ApiResponse<AdminUser>>(
      `${environment.apiBaseUrl}/admin/users/${id}/disable`,
      {}
    );
  }

  changeRole(id: string, request: UpdateAdminRoleRequest) {
    return this.http.post<ApiResponse<AdminUser>>(
      `${environment.apiBaseUrl}/admin/users/${id}/role`,
      request
    );
  }

  createAdmin(request: {
    fullName: string;
    email: string;
    password: string;
    role: number | null;
  }) {
    return this.http.post<ApiResponse<AdminUser>>(
      `${environment.apiBaseUrl}/auth/register-admin`,
      request
    );
  }
}